/*
 * お知らせ種別
 */
export default {
  data: function () {
    return {
      // お知らせ.お知らせ種別
      info_type: {
        INFO: 'I',
        TODO: 'T',
        ERROR: 'E'
      },
      // お知らせ.機能番号
      info_function: {
        INFO: '0',
        OCR: '1',
        DAIKO: '2',
        DUPLICATED: '3',
        BCUPDATE: '4',
        NISFA: '5',
        NEWBCCHANGED: '6'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/info.js